import FingoPaper from '@fingo/lib/components/layout/FingoPaper';
import React from 'react';
import { termsTabs } from '../../../routes/profile';

const ProfileSideTerms = () => {
  const tabs = termsTabs();
  return <FingoPaper tabs={tabs} />;
};

export default ProfileSideTerms;
